module.exports = __webpack_public_path__ + "img/Mask-WatercolorTop.31508578.png";